// Small, pure helpers shared across the BellScheduleModal pieces. Kept free of
// React so the ribbon/rows/quick-fill logic stays easy to reason about.

export const pad = (n) => String(n).padStart(2, "0");

// "HH:mm" -> minutes since midnight (null when empty/invalid).
export const toMin = (hm) => {
    if (!hm) return null;
    const [a, b] = String(hm).split(":").map(Number);
    if (!Number.isFinite(a) || !Number.isFinite(b)) return null;
    return a * 60 + b;
};

// minutes since midnight -> "HH:mm".
export const toHM = (m) => pad(Math.floor(m / 60)) + ":" + pad(m % 60);

// minutes since midnight -> "9:45 AM".
export const pretty = (m) => {
    const h = Math.floor(m / 60);
    const x = m % 60;
    return ((h % 12) || 12) + ":" + pad(x) + " " + (h < 12 ? "AM" : "PM");
};

// Safe integer parse with a fallback default.
export const num = (v, d) => {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : d;
};

// Monotonic row ids so React keys stay stable across edits.
let seq = 1;
export const nextId = () => seq++;

// A blank editable row. `music` holds the selected API bell-music option
// ({ value, label, type, url }) or null until the user picks one.
export const blankRow = (o = {}) => ({
    id: nextId(),
    name: "",
    time: "",
    dur: 10,
    music: null,
    ...o,
});

// The id used to identify a bell-music option coming back from
// /bell/music/active/min. The DTO exposes it as `value`; fall back defensively.
export const getMusicId = (item) => item?.value ?? item?.id ?? item?.bellMusicId ?? null;

// Colour category for the ribbon dot / dropdown swatch. The API options do not
// carry a tone bucket, so we derive one from keywords in the type/label. This is
// purely cosmetic and always degrades to the default "bell" (gold) colour.
export const musicClass = (item) => {
    const key = String(item?.type ?? item?.value ?? item?.label ?? "").toLowerCase();
    if (/(siren|emergency|fire|alert|danger)/.test(key)) return "t-alert";
    if (/(notice|info|announce|assembly|prayer)/.test(key)) return "t-info";
    if (/(soft|tune|flute|lunch|anthem|song|greeting|melody)/.test(key)) return "t-soft";
    return "";
};
